
document.addEventListener('DOMContentLoaded', function () {
    const slider = document.getElementById('gallerySlider');
    const track = document.getElementById('sliderTrack');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    const dots = document.querySelectorAll('.dot');
    const slideGap = 16;

    if (!track) return;

    const slides = track.children;
    const totalSlides = slides.length;
    let slidesToShow = window.innerWidth >= 1024 ? 3 : 1;
    let maxSlideIndex = Math.max(0, totalSlides - slidesToShow);
    let currentSlide = 0;
    let isTransitioning = false;

    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let startTransform = 0;

    if (totalSlides <= 1) return;

    function updateResponsiveValues() {
        slidesToShow = window.innerWidth >= 1024 ? 3 : 1;
        maxSlideIndex = Math.max(0, totalSlides - slidesToShow);

        if (currentSlide > maxSlideIndex) {
            currentSlide = maxSlideIndex;
        }
    }

    function getSlideWidth() {
        const containerWidth = slider.offsetWidth;
        return (containerWidth / slidesToShow) + slideGap;
    }

    function updateSlider(animate = true) {
        if (isTransitioning && animate) return;

        if (animate) {
            isTransitioning = true;
            track.style.transition = 'transform 0.5s ease-in-out';
        } else {
            track.style.transition = 'none';
        }

        const slideWidth = getSlideWidth();
        const translateX = -currentSlide * slideWidth;
        track.style.transform = `translateX(${translateX}px)`;

        dots.forEach((dot, index) => {
            if (index === currentSlide) {
                dot.classList.add('bg-black');
                dot.classList.remove('bg-neutrals-500');
            } else {
                dot.classList.remove('bg-black');
                dot.classList.add('bg-neutrals-500');
            }
        });

        const isDesktop = window.innerWidth >= 1024;

        if (prevBtn) {
            if (currentSlide === 0) {
                prevBtn.style.opacity = '0';
                prevBtn.style.pointerEvents = 'none';
                prevBtn.disabled = true;
            } else {
                prevBtn.style.opacity = '1';
                prevBtn.style.pointerEvents = 'auto';
                prevBtn.disabled = false;
            }
        }

        if (nextBtn) {
            if (currentSlide >= maxSlideIndex) {
                nextBtn.style.opacity = '0';
                nextBtn.style.pointerEvents = 'none';
                nextBtn.disabled = true;
            } else {
                nextBtn.style.opacity = '1';
                nextBtn.style.pointerEvents = 'auto';
                nextBtn.disabled = false;
            }
        }

        if (animate) {
            setTimeout(() => {
                isTransitioning = false;
            }, 500);
        }
    }

    function nextSlide() {
        if (currentSlide < maxSlideIndex && !isTransitioning) {
            currentSlide++;
            updateSlider();
        }
    }

    function prevSlide() {
        if (currentSlide > 0 && !isTransitioning) {
            currentSlide--;
            updateSlider();
        }
    }

    function goToSlide(slideIndex) {
        if (isTransitioning) return;
        currentSlide = Math.min(slideIndex, maxSlideIndex);
        updateSlider();
    }

    function getEventX(e) {
        return e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    }

    function handleStart(e) {
        if (isTransitioning) return;

        isDragging = true;
        startX = getEventX(e);
        currentX = startX;

        const slideWidth = getSlideWidth();
        startTransform = -currentSlide * slideWidth;

        track.style.transition = 'none';
        slider.style.cursor = 'grabbing';

        e.preventDefault();
    }

    function handleMove(e) {
        if (!isDragging || isTransitioning) return;

        currentX = getEventX(e);
        const deltaX = currentX - startX;
        const newTransform = startTransform + deltaX;

        track.style.transform = `translateX(${newTransform}px)`;
        e.preventDefault();
    }

    function handleEnd(e) {
        if (!isDragging || isTransitioning) return;

        isDragging = false;
        slider.style.cursor = 'grab';

        const deltaX = currentX - startX;
        const threshold = 50;

        if (Math.abs(deltaX) > threshold) {
            if (deltaX > 0 && currentSlide > 0) {
                prevSlide();
            } else if (deltaX < 0 && currentSlide < maxSlideIndex) {
                nextSlide();
            } else {
                updateSlider();
            }
        } else {
            updateSlider();
        }
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', nextSlide);
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', prevSlide);
    }

    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => goToSlide(index));
    });

    slider.addEventListener('touchstart', handleStart, {
        passive: false
    });
    slider.addEventListener('touchmove', handleMove, {
        passive: false
    });
    slider.addEventListener('touchend', handleEnd);

    slider.addEventListener('mousedown', handleStart);
    slider.addEventListener('mousemove', handleMove);
    slider.addEventListener('mouseup', handleEnd);
    slider.addEventListener('mouseleave', handleEnd);

    document.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
            prevSlide();
        } else if (e.key === 'ArrowRight') {
            nextSlide();
        }
    });

    window.addEventListener('resize', function () {
        updateResponsiveValues();
        updateSlider(false);
    });

    let autoPlayInterval;
    const autoPlayDelay = 5000;

    function startAutoPlay() {
        autoPlayInterval = setInterval(() => {
            if (currentSlide >= maxSlideIndex) {
                goToSlide(0);
            } else {
                nextSlide();
            }
        }, autoPlayDelay);
    }

    function stopAutoPlay() {
        clearInterval(autoPlayInterval);
    }
    slider.addEventListener('mouseenter', stopAutoPlay);
    slider.addEventListener('mouseleave', startAutoPlay);

    slider.addEventListener('touchstart', stopAutoPlay);

    slider.style.cursor = 'grab';

    updateResponsiveValues();
    updateSlider(false);
    // startAutoPlay();
});
